module.exports = __webpack_public_path__ + "images/backgrounds/snow-bokeh/small.d74c2d921e28c822e92b.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/snow-bokeh/small.jpg
// module id = 9s3h
// module chunks = 13